import type {
  OutboundCallResponse,
  RowOutboundCallRequest,
} from '@api-contracts/api';
import type { CallListItem } from '@api-contracts/calls';
import backendHttpClient from '@services/_httpClient/backend.http-client';

import { CallsRepository, type LaunchOutboundCallParams } from './repository';

class CallsService extends CallsRepository {
  public async getCallList(): Promise<Array<CallListItem>> {
    const response = await backendHttpClient.get<Array<CallListItem>>({
      path: '/calls',
    });

    return response.data;
  }

  public async launchOutboundCall({
    rowNumber,
    ...body
  }: LaunchOutboundCallParams): Promise<OutboundCallResponse> {
    const response = await backendHttpClient.post<
      OutboundCallResponse,
      RowOutboundCallRequest
    >({
      body,
      path: `/calls/outbound/${rowNumber}`,
    });

    return response.data;
  }
}

export const callsService = new CallsService();
